var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titles_box"},[_c('div',{staticClass:"zh"},[_vm._v(_vm._s(_vm.zhName))]),_c('div',{staticClass:"en"},[_vm._v(_vm._s(_vm.enName))]),_c('img',{attrs:{"src":require("../assets/home/title_icon.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }